import { Injectable, signal } from '@angular/core';
import { IPopupComponent } from './stadia-maps.types';

@Injectable({ providedIn: 'root' })
export class StadiaMapsPopupService {
  readonly popupComponents = signal<IPopupComponent[]>([]);

  registerPopupComponent(popupComponent: IPopupComponent): void {
    this.popupComponents.update(components => [...components, popupComponent]);
  }

  unregisterPopupComponent(popupComponent: IPopupComponent): void {
    this.popupComponents.update(components =>
      components.filter(component => component !== popupComponent),
    );
  }

  removeAllPopupComponents(): void {
    this.popupComponents().forEach(component => component.hidePopup());
    this.popupComponents.set([]);
  }
}

